// All available options
// https://github.com/remarkjs/react-markdown
// root
// text
// break
// paragraph
// emphasis
// strong
// thematicBreak
// blockquote
// link
// image
// linkReference
// imageReference
// list
// listItem
// definition
// heading
// inlineCode
// code
// html
// virtualHtml
// parsedHtml
// delete
// table
// tableHead
// tableBody
// tableRow
// tableCell

const term = {
  disallowedTypes: [
    'break',
    'paragraph',
    'thematicBreak',
    'blockquote',
    'link',
    'image',
    'linkReference',
    'imageReference',
    'definition',
    'heading',
    'inlineCode',
    'code',
    'html',
    'virtualHtml',
    'parsedHtml',
    'delete',
    'table',
    'tableHead',
    'tableBody',
    'tableRow',
    'tableCell',
  ],
};

const fact = {
  disallowedTypes: [
    'break',
    'thematicBreak',
    'blockquote',
    'link',
    'image',
    'linkReference',
    'imageReference',
    'definition',
    'heading',
    'inlineCode',
    'code',
    'html',
    'virtualHtml',
    'parsedHtml',
    'delete',
    'table',
    'tableHead',
    'tableBody',
    'tableRow',
    'tableCell',
  ],
};

const description = {
  disallowedTypes: [
    'link',
    'image',
    'linkReference',
    'imageReference',
    'html',
    'virtualHtml',
    'parsedHtml',
  ],
};

const stem = {
  disallowedTypes: [
    'link',
    'linkReference',
    'html',
    'virtualHtml',
    'parsedHtml',
  ],
};

const answer = {
  disallowedTypes: [
    'thematicBreak',
    'link',
    'linkReference',
    'heading',
    'html',
    'virtualHtml',
    'parsedHtml',
    'delete',
  ],
};

const explanation = {
  disallowedTypes: [],
};

const blog = {
  disallowedTypes: [],
};

const rules = {
  term,
  fact,
  description,
  stem,
  answer,
  explanation,
  blog,
};

export default rules;
